import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStack2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M12 4l-8 4l8 4l8 -4l-8 -4" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 12l8 4l8 -4" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 16l8 4l8 -4" })
	]
});
export { SvgStack2 as ReactComponent };
